import React, { useState } from "react";
import { Row } from "reactstrap";
import { routeNameValidation } from "../../Shared/validation";
import { IoArrowForwardOutline } from "react-icons/io5";

import "./wizardStep1.scss";

function WizardStep1({ nextPage, setWizardData, wizardData }) {
  const [errors, setErrors] = useState({});

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const handleChange = (e) => {
    errors[e?.target?.name] = null;
    setWizardData({
      ...wizardData,
      [e?.target?.name]: e?.target?.value
        ?.replace(/^\s+/, "")
        ?.replace(regex, ""),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = await routeNameValidation(wizardData);
    if (errors) {
      setErrors(errors);
      return;
    } else {
      nextPage();
    }
    setWizardData({
      routeName: wizardData?.routeName?.trim(),
    });
  };

  return (
    <div className="wizard_step step1">
      <div>
        <div className="nt-wizard_step1">
          <div className="nt-wizard_step1_heading">
            <h2>Plan Your Journey</h2>
            <p>
              Starts with selecting a route name that fits your travel goals.
            </p>
          </div>
          <div className="nt-form_field">
            <form onSubmit={handleSubmit} className="nt-form_step1">
              <input
                id="routeName"
                name="routeName"
                type="text"
                autoComplete="off"
                value={wizardData?.routeName}
                placeholder="Enter a unique route name"
                maxLength="100"
                onChange={handleChange}
              />
              <span className="nt-error">
                {errors?.routeName && errors?.routeName}
              </span>
              <div className="nt-button">
                <button type="submit">
                  <span>Continue to next step</span>
                  <IoArrowForwardOutline style={{ color: "white" }} size={18} />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Row>
        {/* <Col className="bg-light step_section">
            <ul>
              <li>
                Welcome to Wizard, follow a few simple steps and you can
                schedule a route of your liking...!!!!!!
              </li>
            </ul>
            <div className="form_field">
              <Form onSubmit={handleSubmit}>
                <Label>Route Name</Label>
                <Input
                  id="routeName"
                  name="routeName"
                  type="text"
                  autoComplete="off"
                  value={wizardData?.routeName}
                  placeholder="Route Name"
                  maxLength="100"
                  onChange={handleChange}
                />
                <span className="error">
                  {errors?.routeName && errors?.routeName}
                </span>
                <div className="button">
                  <Button type="submit">Next</Button>
                </div>
              </Form>
            </div>
          </Col> */}
      </Row>
    </div>
  );
}

export default WizardStep1;
